<template>
    <div>
        <template v-if="loadingItemData">
            <div class="div__loading">
                <loader />
            </div>
        </template>
        <template v-else>
            <section class="section forum">
                <div class="container">
                    <div class="section__row section__row--between">
                        <h4 class="section__title">{{itemData.title}}</h4>
                    </div>
                    <div>
                        <a @click="$router.go(-1)" class="link">
                            <span class="icon">
                                <svg width="19" height="14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M14.28 3.85H1.34L4.06.8a.48.48 0 1 0-.72-.64L.28 3.6a1.1 1.1 0 0 0 0 1.46L3.34 8.5a.48.48 0 0 0 .68.04c.2-.18.22-.48.04-.68L1.34 4.8h12.94a3.76 3.76 0 0 1 0 7.52H12a.48.48 0 1 0 0 .96h2.28a4.72 4.72 0 0 0 0-9.44z" fill="#000"/>
                                </svg>
                        </span>
                            <button class="btn__plain bg-secondary text-white-70">Go back</button>
                        </a>
                        <button class="btn__plain">report</button>
                        <template v-if="isDiscussionOwner">
                            <button
                                class="btn__plain"
                                @click.prevent="deleteCourseForum"
                            >
                                    Delete Post
                            </button>
                        </template>
                    </div>
                </div>
                <div class="container">
                    <div class="forum__wrapper">
                        <main class="forum__main">
                            <div class="forum__body">
                                <div class="forum__thread">
                                    <ul class="">
                                        <li class="forum__post item__row">
                                            <img class="post__img" :src="itemData.user.avatar" alt="">
                                            <div class="item__body">
                                                <div class="">
                                                    <span class="title bold">
                                                        <span class="title bold">{{`${itemData.user.fname} ${itemData.user.lname}`}}</span>
                                                    </span>
                                                    <span class="grey">{{ itemData.created_at | date }}</span>
                                                </div>
                                                <p class="forum__text">{{itemData.description}}</p>
                                            </div>
                                        </li>
                                        <li class="forum__post item__row">
											<img v-if="itemData.user.avatar" class="post__img" :src="itemData.user.avatar" alt="">
											<img v-else class="post__img" src="../../assets/img/profile.jpg" alt="">
                                            <form
                                                @submit.prevent="createThread"
                                                class="forum__post__form item__body" action="">
                                                <label
                                                    class="label--block"
                                                    for="forum-thread">
                                                    <textarea
                                                        class="input input--lg"
                                                        :class="[{ 'is-invalid': errors.body}]"
                                                        name=""
                                                        id="forum-thread"
                                                        cols="50"
                                                        rows="3"
                                                        @keydown="clearErrors($event.target.name)"
                                                        v-model="comment.body"
                                                        placeholder="Type here to reply..."></textarea>
                                                </label>
                                                <div class="btn-group">
                                                <button
                                                    :v-bind="{'disabled': loading || !comment.body}"
                                                    type="submit"
                                                    @click.prevent="createThread"
                                                    class="btn__primary btn__primary--alt">Post Comment</button>
                                                    <Loader v-if="loading"/>
                                                </div>
                                            </form>
                                        </li>
                                    </ul>
                                    <h5 v-if="threads.length" class="bold">{{ threads.length }} comments</h5>
                                    <ul class="forum__thread">
                                        <template>
                                            <template v-if="threads.length > 0">
                                                <li
                                                    v-for="thread in threads"
                                                    :key="thread.id">
                                                    <div class="forum__post item__row thread">
                                                        <img class="post__img post__img--sm" :src="thread.user.avatar" alt="">
                                                        <div class="item__body">
                                                            <p class="forum__text">
                                                                <span class="bold">
                                                                    {{`${thread.user.fname} ${thread.user.lname}`}}
                                                                </span>
                                                                {{thread.body}}
                                                            </p>
                                                            <div class="item__meta">
                                                                <span>
                                                                    {{ thread.created_at | date}}
                                                                </span>
                                                                <template v-if="isThreadOwner">
                                                                    <button class="btn__plain btn__plain--sm" @click="deleteCourseDiscussionThread(thread.id)">Delete</button>
                                                                </template>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </li>
                                            </template>
                                            <template v-else>
                                                No comments
                                            </template>
                                        </template>
                                    </ul>
                                </div>
                            </div>
                        </main>
                    </div>
                </div>
            </section>
        </template>
    </div>
</template>


<script>
import { mapGetters, mapMutations, mapActions } from 'vuex';
import
{
	getDiscussionThread,
	createDiscussionThread,
	deleteCourseForum,
	getDiscussionThreadList,
	deleteCourseDiscussionThread
} from '../../utils/api/course';
import courseForum from '../../utils/validations/course';
import form from '../../mixins/form';
import { success, fail } from '../../utils/toast';
import Loader from '../../components/Loader';

export default {
	name: 'DiscussionPage',
	mixins: [form],
	props: {
		joinedCourse: [Boolean, String]
	},
	data() {
		return {
			loadingItemData: true,
			itemData: {},
			itemDataLoaded: false,
			threads: [],
			loadingThreads: true,
			threadsLoaded: false,
			errors: {},
			comment: {
				body: ''
			},
			loading: false,
			isDiscussionOwner: false,
			isThreadOwner: false
		};
	},
	mounted() {
		this.getDiscussionThread();
		this.getDiscussionThreadList();
	},
	methods: {
		getDiscussionThread() {
			const { id, discussionId } = this.$route.params;
			getDiscussionThread(id, discussionId)
				.then((response) => {
					if (response.status === 200) {
						this.itemData = response.data.data;
						if (this.itemData.user_id === this.loggedUser.id) {
							this.isDiscussionOwner = true;
							return true;
						}
						this.itemDataLoaded = true;
						return true;
					}
					this.itemDataLoaded = false;
					return false;
				}).catch((error) => {
					this.itemDataLoaded = false;
					return false;
				}).finally(() => {
					this.loadingItemData = false;
				});
		},
		createThread() {
			this.validate(this.comment, courseForum.thread);
			if (Object.keys(this.issues).length > 0) {
				this.errors = this.issues;
				return false;
			}

			const { id, discussionId } = this.$route.params;

			createDiscussionThread(
				id,
				discussionId,
				{
					...this.comment,
					class_forum_id: discussionId,
					user_id: this.loggedUser.id
				}
			)
				.then((response) => {
					if (response.status === 201) {
						success({
							title: 'Success! Added new discussion comment.'
						});
						this.comment.body = '';
						this.threads.unshift({ ...response.data, user: this.loggedUser });
						this.threadsLoaded = true;
						return true;
					}
					this.threadsLoaded = false;
					return false;
				}).catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
					this.threadsLoaded = false;
					return false;
				});
			return true;
		},
		deleteCourseForum() {
			const { id, discussionId } = this.$route.params;
			deleteCourseForum(id, discussionId)
				.then((response) => {
					if (response.status === 200) {
						success({
							title: 'Success! Course Discussion has been deleted.'
						});
						this.$router.push(`/courses/${id}`);
						return true;
					}
					return false;
				}).catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
					return false;
				});
			return true;
		},
		getDiscussionThreadList() {
			const { id, discussionId } = this.$route.params;
			getDiscussionThreadList(id, discussionId)
				.then((response) => {
					if (response.status === 200) {
						this.threads = response.data.data;
						this.threads.forEach((thread) => {
							if (thread.user_id === this.loggedUser.id) {
								this.isThreadOwner = true;
								return true;
							}
							return false;
						});
						this.threadsLoaded = true;
						return true;
					}
					this.threadsLoaded = false;
					return false;
				}).catch((error) => {
					this.threadsLoaded = false;
					return false;
				}).finally(() => {
					this.loadingThreads = false;
				});
		},
		deleteCourseDiscussionThread(value) {
			const { id, discussionId } = this.$route.params;
			const threadId = value;
			deleteCourseDiscussionThread(id, discussionId, threadId)
				.then((response) => {
					if (response.status === 200) {
						this.threads.shift({ ...response.data });
						success({
							title: 'Success! Discussion thread has been deleted.'
						});
						return true;
					}
					return false;
				}).catch((error) => {
					fail({
						title: 'Oops! Something went wrong',
						text: error.data
					});
					return false;
				});
			return true;
		}
	},
	filters: {
		date(value) {
			return moment(value).fromNow();
		}
	},
	components: {
		Loader
	},
	computed: {
		...mapGetters({
			loggedUser: 'getLoggedUser'
		})
	}
};
</script>

<style scoped>
.div__loading {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
}
</style>
